import { render, staticRenderFns } from "./LoanScreenedButton.vue?vue&type=template&id=29b54106&"
import script from "./LoanScreenedButton.vue?vue&type=script&lang=js&"
export * from "./LoanScreenedButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports